import { render, staticRenderFns } from "./TwoCol.vue?vue&type=template&id=331cae25&scoped=true&"
import script from "./TwoCol.vue?vue&type=script&lang=js&"
export * from "./TwoCol.vue?vue&type=script&lang=js&"
import style0 from "./TwoCol.vue?vue&type=style&index=0&id=331cae25&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331cae25",
  null
  
)

export default component.exports